import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="bg-black/90 backdrop-blur-md shadow-2xl sticky top-0 z-50 border-b border-green-500 min-w-[350px] beetlejuice-glow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Title */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <h1 className="text-lg sm:text-xl lg:text-2xl font-bold beetlejuice-green-text animate-beetlejuice-pulse">
              🦇 UTB Strašidelná fakulta 🦇
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <Link
              to="/"
              className="beetlejuice-green text-black px-6 py-2 rounded-full beetlejuice-hover font-medium beetlejuice-border"
            >
              🏠 Domů
            </Link>
            <Link
              to="/reservations"
              className="beetlejuice-green text-black px-6 py-2 rounded-full beetlejuice-hover font-medium beetlejuice-border"
            >
              💀 Rezervovat
            </Link>
            <Link
              to="/manage"
              className="beetlejuice-green text-black px-6 py-2 rounded-full beetlejuice-hover font-medium beetlejuice-border"
            >
              ⚰️ Spravovat
            </Link>
            <Link
              to="/info"
              className="beetlejuice-green text-black px-6 py-2 rounded-full beetlejuice-hover font-medium beetlejuice-border"
            >
              📊 Info
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="beetlejuice-green text-black p-2 rounded-lg beetlejuice-hover beetlejuice-border"
              aria-label="Toggle mobile menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-black/95 backdrop-blur-md rounded-lg mt-2 border border-green-500 beetlejuice-glow">
              <Link
                to="/"
                className="block beetlejuice-green text-black px-4 py-3 rounded-lg beetlejuice-hover font-medium beetlejuice-border"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                🏠 Domů
              </Link>
              <Link
                to="/reservations"
                className="block beetlejuice-green text-black px-4 py-3 rounded-lg beetlejuice-hover font-medium beetlejuice-border"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                💀 Rezervovat
              </Link>
              <Link
                to="/manage"
                className="block beetlejuice-green text-black px-4 py-3 rounded-lg beetlejuice-hover font-medium beetlejuice-border"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                ⚰️ Spravovat
              </Link>
              <Link
                to="/info"
                className="block beetlejuice-green text-black px-4 py-3 rounded-lg beetlejuice-hover font-medium beetlejuice-border"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                📊 Info
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
